import { Alert, Button } from 'react-bootstrap';

const InquiryFormExtras = ({
  honeypotId,
  websiteField,
  setWebsiteField,
  turnstileRef,
  showTurnstileConfigWarning,
  error,
  status,
  confirmation,
  onReset,
}) => {
  if (status === 'success') {
    return (
      <Alert variant="success" className="mb-0" role="status">
        <Alert.Heading className="h5">Thank you</Alert.Heading>
        <p className="mb-2">{confirmation?.message || 'We received your message and emailed a confirmation.'}</p>
        {confirmation?.reference ? (
          <p className="mb-3">
            Reference <strong>#{confirmation.reference}</strong>
          </p>
        ) : null}
        {typeof onReset === 'function' ? (
          <Button variant="outline-success" size="sm" type="button" onClick={onReset}>
            Send another message
          </Button>
        ) : null}
      </Alert>
    );
  }

  return (
    <>
      <div className="position-absolute" style={{ left: '-10000px', top: 'auto', width: 1, height: 1, overflow: 'hidden' }} aria-hidden>
        <label htmlFor={honeypotId}>Website</label>
        <input
          id={honeypotId}
          type="text"
          tabIndex={-1}
          autoComplete="off"
          value={websiteField}
          onChange={(event) => setWebsiteField(event.target.value)}
        />
      </div>
      {showTurnstileConfigWarning ? (
        <Alert variant="warning" className="small py-2 mb-0">
          Turnstile is not configured for this environment. Set <code>NEXT_PUBLIC_TURNSTILE_SITE_KEY</code> (or the legacy alias) to enable secure submission.
        </Alert>
      ) : null}
      <div ref={turnstileRef} />
      {error ? <Alert variant="danger" className="mb-0">{error}</Alert> : null}
    </>
  );
};

export default InquiryFormExtras;
